import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35670efe")

_pushScopeId("data-v-35670efe")
const _hoisted_1 = { class: "infinite" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OProgressSpinner = _resolveComponent("OProgressSpinner")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_OProgressSpinner, { class: "infinite__spinner" })
    ], 512), [
      [_vShow, _ctx.showSpinner]
    ]),
    _withDirectives(_createVNode("div", { class: "infinite__error" }, _toDisplayString(_ctx.errorMsg), 513), [
      [_vShow, _ctx.showError]
    ])
  ]))
})